import React from 'react';
import { Timezone } from 'framework/types';

export type Me = {
  alias?: string;
  timezone?: Timezone;
  mainPhotoId?: Nullable<string>;
  nameEn?: {
    firstName?: string;
    lastName?: string;
    maidenName?: string;
  };
  workingEmail?: Nullable<string>;
  artifacts?: Dictionary<{
    thumbnails?: Dictionary<string>;
  }>;
};

type AuthenticatedUserDependencies = {
  useMeService: () => {
    getMe: () => Promise<Me>;
  };
  useArtifactInfoService: () => {
    getThumbnails: (artifactId: string) => Promise<Dictionary<string>>;
  };
  isLinkExpired: (url: string) => boolean;
};

const AuthenticatedUserDependenciesContext = React.createContext<Nullable<AuthenticatedUserDependencies>>(null);

export const AuthenticatedUserDependenciesProvider = ({
  children,
  value,
}: {
  children: React.ReactNode;
  value: AuthenticatedUserDependencies;
}) =>
  React.createElement(AuthenticatedUserDependenciesContext.Provider, {
    value,
    children,
  });

export const useAuthenticatedUserDependencies = (): AuthenticatedUserDependencies => {
  const dependencies = React.useContext(AuthenticatedUserDependenciesContext);

  if (!dependencies) {
    throw new Error('Authenticated user dependencies are missing');
  }

  return dependencies;
};
